import interceptor from 'rest/interceptor';
import { parseServerValue } from '../helpers/server_value_parser';

const requestIsJSON = ({ request }) => {
	return request && request.mime.match(/application\/json/);
};

const requestIsGET = ({ request }) => {
	return request && request.method === 'GET';
};

const parseResponseValues = (response) => {
	if (response.entity === '') {
		throw new Error('IsEntityResponseEmpty');
	}

	const parsedEntity = JSON.parse(response.entity);
	parseResponseValuesItem(parsedEntity);	
	return parsedEntity;
};

const parseResponseValuesItem = (item) => {
	if(Array.isArray(item)) {
		item.forEach(parseResponseValuesItem);
	}
	else if(item && typeof item === 'object') {
		Object.keys(item).forEach((key) => { parseResponseObjectItem(key, item) });
	}
};

const parseResponseObjectItem = (key, parent) => {
	const item = parent[key];
	if(key === 'value') {
		parent[key] = parseServerValue(item, key, parent);
	} else {
		parseResponseValuesItem(item);
	}
};

const parseResponseWithValues = (response, config, meta) => {
	if (!requestIsJSON(response) || !requestIsGET(response)) return response;
	const parsedResponse = Object.assign({}, response);
	parsedResponse.entity = JSON.stringify(parseResponseValues(parsedResponse));	
	return parsedResponse;
};

const ValuesParserInterceptor = interceptor({
	response: parseResponseWithValues
});

export default ValuesParserInterceptor;
